import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'cricteams-billing-toggle',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './billing-toggle.component.html',
  styleUrl: './billing-toggle.component.scss',
})
export class BillingToggleComponent {
  @Input() selectedInterval: 'Monthly' | 'Yearly' = 'Monthly';
  @Input() savingsPercent = 0;
  @Output() intervalChange = new EventEmitter<'Monthly' | 'Yearly'>();

  select(interval: 'Monthly' | 'Yearly') {
    if (interval !== this.selectedInterval) {
      this.selectedInterval = interval;
      this.intervalChange.emit(interval);
    }
  }
}
